import React from 'react'
import PropTypes from 'prop-types'

const CardInfoFidelityProgramDetails = ({width, height, children}) => {
  return (
    <div className="card-info-fidelity-program-details"
      style={{width: width, height: height}}>
        { children }
    </div>
  )
}

CardInfoFidelityProgramDetails.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  children: PropTypes.any.isRequired
}

CardInfoFidelityProgramDetails.defaultProps = {
  width: '100%',
  height: null
}

export default CardInfoFidelityProgramDetails;